module.exports = __webpack_public_path__ + "media/svg/ba-6b95169b.svg";